import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { ScheduledMessagesList } from '@/features/mattermost/components/ScheduledMessagesList';
import { BroadcastListsSection } from '@/features/mattermost/components/BroadcastListsSection';
import { useQueryClient } from '@tanstack/react-query';

export const Route = createFileRoute('/_authenticated/mattermost-scheduled-messages')({
  component: MattermostScheduledMessagesPage,
});

function MattermostScheduledMessagesPage() {
  const queryClient = useQueryClient();
  const routerState = useRouterState();
  const isNewRoute =
    routerState.location.pathname === '/mattermost-scheduled-messages/new';

  const handleEdit = () => {
    // Edição pode ser implementada em uma tela futura se necessário
    queryClient.invalidateQueries({ queryKey: ['scheduled-messages'] });
  };

  return (
    <PermissionGate permission={Permission.MATTERMOST_SEND_MESSAGE}>
      {isNewRoute ? (
        <Outlet />
      ) : (
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold">Agendador de Mensagens</h1>
              <p className="text-muted-foreground mt-2">
                Agende mensagens para serem enviadas automaticamente no Mattermost
              </p>
            </div>
          </div>

          <Tabs defaultValue="messages" className="space-y-4">
            <TabsList>
              <TabsTrigger value="messages">Mensagens agendadas</TabsTrigger>
              <TabsTrigger value="lists">Listas de transmissão</TabsTrigger>
            </TabsList>

            <TabsContent value="messages" className="space-y-6">
              <div className="flex items-center justify-end">
                <Button asChild>
                  <Link to="/mattermost-scheduled-messages/new">
                    <Plus className="mr-2 h-4 w-4" />
                    Nova Mensagem
                  </Link>
                </Button>
              </div>
              <ScheduledMessagesList onEdit={handleEdit} />
            </TabsContent>

            <TabsContent value="lists">
              <BroadcastListsSection />
            </TabsContent>
          </Tabs>
        </div>
      )}
    </PermissionGate>
  );
}

